import React, { Component } from "react";
import { Link } from "react-router-dom";
import Files from "react-files";
import { FILE_FORMATS, ERROR_MSG, FILE_SIZE_LIMIT } from "../../constant";
import { Image } from "react-bootstrap";
import IconPin from "../../assets/icon-pin.png";
import { FormDataForImage } from "../../helper";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  uploadFileAction,
  removeFileAction
} from "../../actions/common.action";
import { toast } from "react-toastify";
import { STATUS } from "../../constant";
import { successToastStyle, errorToastStyle } from "../../customToast";

class FileComponent extends Component {
  state = {
    files: []
  };

  componentWillReceiveProps(nextProps, nextContext) {
    const { reset } = nextProps;
    if (reset) {
      this.setState(
        {
          files: []
        },
        () => {
          this.returnUploadedImageList();
        }
      );
    }
  }

  onUploadFile = async file => {
    const { uploadFileDispatch, getUploadedFiles, getImageStatus } = this.props;
    typeof getImageStatus == "function" && getImageStatus(STATUS.LOADING);
    const attachmentPayload = FormDataForImage(file, "file");
    attachmentPayload.append("isMis", false);
    const response = await uploadFileDispatch(undefined, attachmentPayload);
    try {
      if (!this.inValidFile) {
        if (response) {
          const { status, message, data } = response;
          (status &&
            toast.success(
              <p className="toast-text-alignment">{message}</p>,
              successToastStyle
            )) ||
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          if (status) {
            this.setState(
              prevState => {
                const files = prevState.files;
                prevState.files = prevState.files || [];
                prevState.files = [
                  ...prevState.files,
                  { ...files, extension: file[0].extension, ...data }
                ];
                getUploadedFiles(prevState.files);
                return {
                  files: [...prevState.files]
                };
              },
              () => {
                this.returnUploadedImageList();
              }
            );
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
            </p>,
            errorToastStyle
          );
        }
      }
      this.inValidFile = false;
      typeof getImageStatus === "function" && getImageStatus(STATUS.SUCCESS);
    } catch (e) {
      typeof getImageStatus === "function" && getImageStatus(STATUS.ERROR);
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  onRemoveFile = async (file, index) => {
    const { removeFileDispatch, getUploadedFiles, getImageStatus } = this.props;
    typeof getImageStatus === "function" && getImageStatus(STATUS.LOADING);
    const response = await removeFileDispatch(undefined, {
      fid: file.id
    });
    try {
      if (response) {
        const { status, message } = response;
        (status &&
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )) ||
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        typeof getImageStatus === "function" &&
          getImageStatus((status && STATUS.SUCCESS) || STATUS.ERROR);
        status &&
          this.setState(
            prevState => {
              prevState.files.splice(index, 1);
              getUploadedFiles(prevState.files);
              return {
                files: [...prevState.files]
              };
            },
            () => {
              this.returnUploadedImageList();
            }
          );
      } else {
        typeof getImageStatus === "function" && getImageStatus(STATUS.ERROR);
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } catch (e) {
      typeof getImageStatus === "function" && getImageStatus(STATUS.ERROR);
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  onFilesError = () => {
    toast.error(
      <p className="toast-text-alignment">Invalid File Type</p>,
      errorToastStyle
    );
    this.inValidFile = true;
  };

  returnUploadedImageList = () => {
    const { attachmentsClass, imageListTemplate } = this.props;
    const { files } = this.state;
    typeof imageListTemplate === "function" &&
      imageListTemplate(
        <div className={`${attachmentsClass || ""} upload`}>
          {(files || []).map((value, index) => (
            <div className="uploaded-file-wrapper">
              <div className="uploaded-file">
                <div
                  className="remove-file"
                  onClick={this.onRemoveFile.bind(this, value, index)}
                />
                <div className="file-detail">
                  <div className="upload-icon">{value.extension}</div>
                  <Link to="#" className="file-name">
                    {value.name}
                  </Link>
                  {/*<span className="file-size">({value.size})</span>*/}
                </div>
              </div>
            </div>
          ))}
        </div>
      );
  };

  getImageStatus = imageStatus => {
    this.setState({
      imageStatus
    });
  };

  render() {
    const { attachInputClass } = this.props;
    return (
      <React.Fragment>
        <div className={`${attachInputClass || ""}`}>
          <Files
            className="add-attachment"
            accepts={FILE_FORMATS}
            multiple={false}
            maxFileSize={FILE_SIZE_LIMIT.OTHER_FORMATS}
            minFileSize={0}
            clickable
            onChange={this.onUploadFile}
            onError={this.onFilesError}
          >
            <div className="add-attachment-button">
              <Image src={IconPin} alt="Attachment Icon" />
              Add Attachment
            </div>
          </Files>
        </div>
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      uploadFileDispatch: uploadFileAction,
      removeFileDispatch: removeFileAction
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    isImageUpLoading: state.commonReducer.isImageUpLoading
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FileComponent);
